<div class="actions">
  @if (this.doCombine() && !this.hideAllActions()) {
    <div [ngClass]="{ 'action-compact-frame': isCompactMode(), '': !isCompactMode() }">
      <button
        mat-icon-button
        matTooltip="Actions"
        [matMenuTriggerFor]="moreActions"
        color="primary"
        [attr.data-testid]="'datatable-actions'"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>
    <mat-menu #moreActions="matMenu" class="more-actions-menu">
      @for (action of this.actions(); track $index) {
        @if (doShow(action)) {
          <div [matTooltip]="getHoverText(action)">
            <button
              mat-menu-item
              (click)="action.onClick(row())"
              [disabled]="action.doDisable?.(row())"
              [attr.data-testid]="action.testId"
            >
              @if (action.svgIcon) {
                <mat-icon
                  [color]="action.doDisable?.(row()) ? undefined : (action.color ?? 'primary')"
                  [ngClass]="action.color"
                  [svgIcon]="action.svgIcon"
                ></mat-icon>
              } @else {
                <mat-icon
                  [color]="action.doDisable?.(row()) ? undefined : (action.color ?? 'primary')"
                  [ngClass]="action.color"
                  >{{ action.matIcon }}
                </mat-icon>
              }
              {{ action.label }}
            </button>
          </div>
        }
      }
    </mat-menu>
  } @else {
    @for (action of this.actions(); track $index) {
      @if (doShow(action)) {
        <div
          [ngClass]="{ 'action-compact-frame': isCompactMode(), '': !isCompactMode() }"
          [matTooltip]="getHoverText(action)"
        >
          <button
            mat-icon-button
            (click)="action.onClick(row())"
            [disabled]="action.doDisable?.(row())"
            [ngClass]="{ 'compact-class': isCompactMode, 'default-class': !isCompactMode }"
          >
            @if (action.svgIcon) {
              <mat-icon
                [color]="action.doDisable?.(row()) ? undefined : (action.color ?? 'primary')"
                [ngClass]="action.color"
                [svgIcon]="action.svgIcon"
              ></mat-icon>
            } @else {
              <mat-icon
                [color]="action.doDisable?.(row()) ? undefined : (action.color ?? 'primary')"
                [ngClass]="action.color"
                >{{ action.matIcon }}
              </mat-icon>
            }
          </button>
        </div>
      }
    }
  }
</div>
